import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'ebs-document-reader-dialog',
  templateUrl: './document-reader-dialog.component.html',
  styleUrls: ['./document-reader-dialog.component.scss'],
})
export class DocumentReaderDialogComponent {
  public get fileSrc(): string {
    return this.config.data.fileSrc;
  }

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
  ) {}
}
